module.exports = __webpack_public_path__ + "img/icon-3.7df38fd5.png";